import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateDefaultParser, TranslateModule } from '@ngx-translate/core';
import { TranslationService } from './translation.service';
import { TranslatePipe } from './translate.pipe';
import * as en from './lang/en.json';
import * as de from './lang/de.json';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      defaultLanguage: TranslationService.getDefaultLanguage(),
    }),
  ],
  providers: [TranslateDefaultParser, TranslationService],
  declarations: [TranslatePipe],
  exports: [TranslatePipe],
})
export class I18nModule {
  constructor(private translationService: TranslationService) {
    this.translationService.addTranslation({
      translations: {
        en: en,
        de: de,
      },
    });
  }
}
